import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/alin-bolgesine-dolgu-uygulamasi-nedir-nasil-yapilir/page.tsx");
